(function () {
  function goTo(carousel, index) {
    var panels = carousel.querySelectorAll('.ld-hero__panel');
    var dots = carousel.querySelectorAll('.ld-hero__dot');
    if (!panels.length) return;

    if (index < 0) index = panels.length - 1;
    if (index >= panels.length) index = 0;

    panels.forEach(function (panel, i) {
      var on = i === index;
      panel.classList.toggle('is-active', on);
      panel.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
    dots.forEach(function (dot, i) {
      var on = i === index;
      dot.classList.toggle('is-active', on);
      dot.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var dot = event.target.closest('.ld-hero__dot');
    if (!dot) return;

    var carousel = dot.closest('[data-ld-hero]');
    if (!carousel) return;

    event.preventDefault();
    goTo(carousel, parseInt(dot.getAttribute('data-panel-index'), 10));
  });
})();
